import { takeEvery, fork, put, all, call, select } from "redux-saga/effects";
import {
    getAccountantsError,
    getAccountantsSuccessful,
    setAccountantQuery
} from "./actions";
import AccountantService from "./service";
import { AccountantActionTypes } from "./actionTypes";

// Selector to get the accountant query state from the Redux store.
export const getAccountantQuery = state => state.Accountant.query;

function* get({payload}) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getAccountantQuery);
        // The payload from the action can override the stored query for this specific call.
        const finalPayload = { ...storedQuery, ...payload };
        const response = yield call(AccountantService.getAccountants, finalPayload);
        yield put(getAccountantsSuccessful(response));
        yield put(setAccountantQuery(finalPayload));
    } catch (error) {
        yield put(getAccountantsError(error));
    }
}

export function* watchGetAccountant() {
    yield takeEvery(AccountantActionTypes.ACCOUNTANT_LIST_GET, get);
}



function* accountantsSaga() {
    yield all([
        fork(watchGetAccountant)
    ]);
}

export default accountantsSaga;
